import script from "./StudentManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentManagement.vue?vue&type=script&setup=true&lang=js"

import "./StudentManagement.vue?vue&type=style&index=0&id=159c01c2&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159c01c2"]])

export default __exports__